import { HomeView } from '../pages/home/HomeView';

/**
 * Home de la app mobile: la misma de la web (`HomeView`: buscador, categorías y artículos de la base de conocimiento). El fondo oscuro
 * lo pone `PwaShell` (en la web lo pone `AppShell`); acá solo el ancho y el aire, que en la web da `MainLayout`.
 * Solo la ven quienes tienen acceso a Home (`useNzJourneyStatus.canAccessHome`): `PwaShell` oculta la pestaña y la ruta al resto.
 */
export function PwaHome() {
  return (
    <main className="mx-auto w-full max-w-3xl px-4 pb-6 pt-4 text-left font-[Poppins,sans-serif]">
      <HomeView />
    </main>
  );
}
